import { ParentTypes as Parent_Type_Enum } from '@risksmart-app/domain/src/types/consts/parent-type';
import type { ThirdPartyOptionsResponseRow } from '@risksmart-app/drizzle/src/types';
import type {
  GetThirdPartyOptionsQuery,
  Third_Party_Bool_Exp,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetThirdPartyOptionsDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

import useEntityWhereFilter from '@/hooks/useEntityWhereFilter';

export type ThirdPartyOption = ThirdPartyOptionsResponseRow;

const useThirdPartyOptionsGraphqlVariables = () => ({
  where: useEntityWhereFilter<Third_Party_Bool_Exp>(
    Parent_Type_Enum.ThirdParty
  ),
});

export const useGetThirdPartyOptions = createQueryHook<
  Record<string, never>,
  ThirdPartyOption[],
  GetThirdPartyOptionsQuery
>({
  trpcQueryOptions: (trpc) => trpc.frontend.thirdParty.options.queryOptions(),
  mapTrpcDataToGraphQL: (thirdPartyOptions) => ({
    third_party: thirdPartyOptions,
  }),
  graphqlDocument: GetThirdPartyOptionsDocument,
  graphqlVariables: useThirdPartyOptionsGraphqlVariables,
});
